import React from "react";
import moment from "moment";
import EditIcon from "../../assets/editIcon.png";
import DeleteIcon from "../../assets/deleteIcon.png";

function StaffListMob({staffList, staffEdit, staffDelete}) {
  return (
    <>
      {staffList.map((details, indx) => (
        <div className="staff-list-mob mb-2 px-3 pt-3" key={indx}>
          <div className="row">
            <div className="col-6">
              <div className="staff-heading-mob">STAFF NAME</div>
              <div>
                {details?.first_name} {details?.middle_name} {details?.last_name}
              </div>
            </div>
            <div className="col-6">
              <div className="staff-heading-mob">PHONE NUMBER</div>
              <div>{details.phone_no}</div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="staff-heading-mob col-12">ADDED ON</div>
            <div className="col-12">
              {moment(details.created_at).format("MMM DD, YYYY")} at{" "}
              {moment(details.created_at).format("hh:mm A")}
            </div>
          </div>
          <div className="row mt-3">
            <div
              className="col-6 edit-delete-mob py-2"
              style={{borderRight: "1px solid #E8E8E8", cursor: "pointer"}}
              onClick={() => staffEdit(details.staff_id)}
            >
              <img src={EditIcon} alt="edit" className="mx-auto" />
              <span className="text-center">Edit Details</span>
            </div>
            <div
              className="col-6 edit-delete-mob py-2"
              style={{cursor: "pointer"}}
              onClick={() =>
                staffDelete(
                  details.staff_id,
                  details.first_name,
                  details.last_name
                )
              }
            >
              <img src={DeleteIcon} alt="delete" className="mx-auto" />
              <span className="text-center">Delete</span>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default StaffListMob;
